<template>
    <div class="refund-analysis mineAnalaze">
      <!-- 筛选区域 -->
      <div class="pageTop">
        <h2>景区选择</h2>
        <SearchSelect
          className="longSelect"
          v-model="reqForm.storeIdList"
          :options="storeOptions"
          :props="{
            label: 'label',
            value: 'value',
          }"
          placeholder="请选择景区"
        />
  
        <h2>类型:</h2>
        <el-select
          class="mineSelect"
          v-model="category"
          placeholder="请选择"
          multiple
          v-collapse-tags="2"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
  
        <h2>时间:</h2>
        <el-date-picker
          v-model="reqForm.timeRange"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          :clearable="false"
          style="width: 300px"
        >
        </el-date-picker>
  
        <el-button @click="handleQuery">查询</el-button>
      </div>
  
      <!-- 数据统计区域 -->
      <div class="statistics-section">
        <div class="stat-card">
          <div class="stat-item">
            <h3>
            订单数量
            <el-tooltip effect="light" placement="top" class="custom-tooltip">
              <div slot="content">
                <br />
                <el-button type="text">同笔订单多次退款算作一笔</el-button>
                <br />
              </div>
              <i class="custom-question">?</i>
            </el-tooltip>
            </h3>
            <div class="stat-value">
              {{ formatNumber(summary.total_orders) }}
            </div>
            <!-- <div class="stat-desc">一笔订单，存在多次退款，算做1</div> -->
          </div>
        </div>
  
        <div class="stat-card">
          <div class="stat-item">
            <h3>退款订单</h3>
            <div class="stat-value">
              {{ formatNumber(summary.refund_total_orders) }}
            </div>
            <!-- <div class="stat-desc">退款订单</div> -->
          </div>
        </div>
  
        <div class="stat-card">
          <div class="stat-item">
            <h3>
              退款次数
              <el-tooltip effect="light" placement="top" class="custom-tooltip">
              <div slot="content">
                <br />
                <el-button type="text">同笔订单多次退款次数叠加</el-button>
                <br />
              </div>
              <i class="custom-question">?</i>
            </el-tooltip>
            </h3>
            <div class="stat-value">
              {{ formatNumber(summary.refund_total_refund_num) }}
            </div>
            <!-- <div class="stat-desc">部分退款，次数叠加</div> -->
          </div>
        </div>
  
        <div class="stat-card">
          <div class="stat-item">
            <h3>
              订单退款率
              <el-tooltip effect="light" placement="top" class="custom-tooltip">
              <div slot="content">
                <br />
                <el-button type="text">退款订单/订单总数</el-button>
                <br />
              </div>
              <i class="custom-question">?</i>
            </el-tooltip>
            </h3>
            <div class="stat-value">
              {{
                summary.total_orders > 0
                  ? ((unshippedCount / summary.total_orders) * 100).toFixed(2)
                  : '0.00'
              }}%
            </div>
            <!-- <div class="stat-desc">退款订单/订单总数</div> -->
          </div>
        </div>
      </div>
  
      <!-- 自动退款和手动退款 -->
      <!-- <div class="refund-type-section">
        <h2>自动退款和手动退款</h2>
        <div class="refund-type-stats">
          <div class="refund-type-item">
            <span>自动退款：</span>
            <span>{{ formatNumber(refundTypeStats.autoRefund) }}笔</span>
          </div>
          <div class="refund-type-item">
            <span>手动退款：</span>
            <span>{{ formatNumber(refundTypeStats.manualRefund) }}笔</span>
          </div>
        </div>
      </div> -->
  
      <!-- 分析区域 -->
      <div class="analysis-section">
        <!-- 退款原因分析 -->
        <div class="analysis-card">
          <div class="card-header">
            <h3>退款原因分析</h3>
            <el-button @click="showReasonDetail" icon="el-icon-download">下载</el-button>
          </div>
          <div class="reason-list">
            <div
              v-for="(reason, index) in refund_reason_analysis"
              :key="index"
              class="reason-item"
            >
              <span class="reason-name">{{ reason.reason | reasonFilter }}</span>
              <span class="reason-count">{{ formatNumber(reason.count) }}笔</span>
              <span class="reason-rate">({{ reason.percentage }}%)</span>
            </div>
            <!-- 子表：未出货对应的退款订单出货状态（去除出货成功） -->
            <div
              v-for="(reason, idx) in refund_reason_analysis"
              :key="'sub-'+idx"
              v-if="String(reason.reason) === '8'"
              class="sub-status"
            >
              <div class="sub-title">退款订单出货状态（未出货相关）</div>
              <div class="sub-table">
                <div
                  class="sub-row"
                  v-for="(s, i) in unshippedStatusList"
                  :key="'st-'+i"
                >
                  <span class="status-name">{{ s.order_out_status | outStatusFilter }}</span>
                  <span class="status-count">{{ formatNumber(s.count) }}次</span>
                  <span class="status-rate">({{ s.percentage }}%)</span>
                </div>
              </div>
            </div>
            <!-- <div class="reason-note">
              占比加加一起不会是100%，因为有多选情况
            </div> -->
          </div>
        </div>
  
        <!-- 退款订单状态分析 -->
        <div class="analysis-card">
          <div class="card-header">
            <h3>退款订单出货状态分析</h3>
            <!-- 下载入口移除 per requirement -->
            <!-- <el-button @click="showStatusDetail" icon="el-icon-download">下载</el-button> -->
          </div>
          <div class="reason-list">
            <div
              v-for="(status, index) in order_status_analysis"
              :key="index"
              class="reason-item"
            >
              <span class="reason-name">{{
                status.order_out_status | outStatusFilter
              }}</span>
              <span class="reason-count">{{ formatNumber(status.count) }}次</span>
              <span class="reason-rate">({{ status.percentage }}%)</span>
            </div>
            <!-- <div class="status-note">
              全部订单状态等
            </div> -->
          </div>
        </div>
      </div>
  
      <!-- 景区退款分析表格 -->
      <div class="pageTable">
        <div class="pageTop">
          <h1>景区退款分析</h1>
          <el-button @click="downloadTable" icon="el-icon-download"
            >下载</el-button
          >
        </div>
        <el-table 
          :data="currentPageData" 
          style="width: 100%" 
          border 
          max-height="600" 
          v-loading="tableLoading"
          @sort-change="handleSortChange"
        >
          <el-table-column
            prop="company_name"
            label="景区名称"
            min-width="150"
            align="center"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            prop="store_name"
            label="erp仓库名称"
            min-width="150"
            align="center"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            prop="refund_num_sum"
            label="退款订单数"
            min-width="120"
            align="center"
            sortable="custom"
          >
          </el-table-column>
          <el-table-column
            prop="record_count"
            label="退款次数"
            min-width="120"
            align="center"
            sortable="custom"
          >
          </el-table-column>
          <el-table-column
            prop="refund_rate"
            label="退款率"
            min-width="100"
            align="center"
            sortable="custom"
          >
            <template slot-scope="scope">
              {{ (scope.row.refund_rate * 100).toFixed(2) }}%
            </template>
          </el-table-column>
          <el-table-column
            prop="is_auto_1_count"
            label="自动退款订单数"
            min-width="130"
            align="center"
            sortable="custom"
          >
          </el-table-column>
          <el-table-column
            prop="is_auto_0_count"
            label="手动退款订单数"
            min-width="130"
            align="center"
            sortable="custom"
          >
          </el-table-column>
        </el-table>
        
        <!-- 分页组件 -->
        <div class="pagination-container">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="refund_list.length"
            background
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import SearchSelect from "@/views/components/SearchSelect";
  import { getRefundAnalysis,getRefundAnalysisDownload,getRefundAnalysisDownloadTwo,getRefundAnalysisDownloadThree } from "@/api/bi";
  export default {
    name: "RefundAnalysis",
    data() {
      return {
        reqForm: {
          storeIdList: [],
          deviceIdList: [],
          goodsName: "",
          page: 0,
          pageSize: 0,
          timeRange: [],
          storeId: [],
        },
        category: ["1", "2", "3", "4","5","6","7","8"],
        options: [
          { value: "1", label: "771/772" },
          { value: "2", label: "775" },
          { value: "3", label: "776" },
          { value: "4", label: "779" },
          { value: "5", label: "780" },
          { value: "6", label: "781" },
          { value: "7", label: "782" },
          { value: "8", label: "783" }
        ],
        pickerOptions: {
          shortcuts: [
            {
              text: "最近一周",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近一个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近三个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit("pick", [start, end]);
              },
            },
          ],
        },
        order_status_analysis: [],
        refund_list: [],
        refund_reason_analysis: [],
        summary: [],
        // 分页相关数据
        currentPage: 1,
        pageSize: 20,
        tableLoading: false,
        // 排序相关数据
        sortBy: '',
        sortOrder: '',
        unshippedCount: 0 // 新增：未出货订单数量
      };
    },
    props: ["allStore"], // 全部景区列表
    created() {
      this.setRangeDates();
      this.handleQuery();
    },
    mounted() {
      this.initData();
    },
    filters: {
      outStatusFilter(status) {
        const outMap = {
          SUCCESS: "出货成功",
          FAIL: "出货失败",
          CANCEL: "出货取消", // 不应该存在的状态，但由于测试的时候没有按照业务逻辑，所以出现的异常状态。
          OVERTIME: "结果未知",
          ING: "等待出货",
          未知: "未知",
          通讯超时: "通讯超时",
          出货异常: "出货异常",
          还未吐货: "还未吐货",
          出货失败: "出货失败",
          出货超时: "出货超时",
          等待吐货: "等待吐货",
          吐货成功: "吐货成功",
          其它故障: "其它故障",
          电机或传感器故障: "电机或传感器故障"
        };
  
        return outMap[status];
      },
      refundStatusFilter(status) {
        const outMap = {
          AUTOREFUND: "自动退款",
          MANUALREFUND: "手工退款",
          REFUNDALL: "全部退款",
          REFUNDPART: "部分退款",
          "": "未退款", // 待后续使用
        };
        return outMap[status];
      },
      reasonFilter(val) {
        // 统一将传入的值标准化为字符串数组
        // 可能的情况：
        // - val 为数组，如 ["12", "9"]
        // - val 为以逗号分隔的字符串，如 "12,9"
        // - val 为单个字符串编号，如 "12"
        // - val 为空字符串或空数组
        if (val == null) return '-';
  
        let values = [];
        if (Array.isArray(val)) {
          values = val;
        } else if (typeof val === 'string') {
          const trimmed = val.trim();
          if (trimmed === '') return '-';
          // 支持中英文逗号分隔
          if (trimmed.includes(',') || trimmed.includes('，')) {
            values = trimmed.split(/[,，]/).map(s => s.trim()).filter(Boolean);
          } else {
            values = [trimmed];
          }
        } else if (typeof val === 'number') {
          values = [String(val)];
        } else {
          return '-';
        }
  
        const reasons = {
          1: '商品损坏',
          2: '未出货',
          3: '重复支付',
          4: '景区账号退款失败',
          5: '出货与下单商品不符',
          6: '外壳损坏',
          7: '纪念章/大牌/集章册瑕疵',
          8: '未出货',
          9: '重复支付',
          10: '出错货',
          11: '7天无理由',
          12: '测试',
          13: '大牌机器卡死',
          14: '大牌打印瑕疵',
          15: '777不出货',
          16: '777漏墨',
          18: '激光雕刻失败',
          19: '激光雕刻错位',
          20: '商品损坏',
        };
  
        const mapped = values
          .map(code => reasons[Number(code)] || reasons[String(code)] || '-')
          .filter(text => text && text !== '-');
  
        return mapped.length > 0 ? mapped.join('、') : '-';
      },
    },
    methods: {
      initData() {},
      setRangeDates() {
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth(); // 月份从0开始，0为1月
        const day = today.getDate();
  
        // 设置起始日期为当月1号
        const startDate = new Date(year, month, 1);
        // 设置结束日期为当天
        const endDate = new Date(year, month, day);
  
        this.reqForm.timeRange = [
          this.formatDate(startDate),
          this.formatDate(endDate),
        ];
      },
      getReq() {
        var queryForm = { ...this.reqForm };
        if (this.reqForm.timeRange.length > 0) {
          const [startDate, endDate] = this.reqForm.timeRange;
          queryForm.start = startDate; // 直接使用字符串，不需要再格式化
          queryForm.end = endDate; // 直接使用字符串，不需要再格式化
        } else {
          queryForm.start = "";
          queryForm.end = "";
        }
  
        queryForm.storeIdList =
          queryForm.storeIdList.length > 0 ? queryForm.storeIdList : [];
  
        queryForm.deviceIdList =
          queryForm.deviceIdList.length > 0 ? queryForm.deviceIdList : [];
        return queryForm;
      },
      formatDate(date) {
        return (
          date.getFullYear() +
          "-" +
          String(date.getMonth() + 1).padStart(2, "0") +
          "-" +
          String(date.getDate()).padStart(2, "0")
        );
      },
  
      formatNumber(value) {
        if (typeof value === "object" && value.refundOrders) {
          return value.refundOrders.toLocaleString();
        }
        return value ? value.toLocaleString() : "0";
      },
  
      handleQuery() {
        var queryForm = this.getReq();
        let params = {
          start: queryForm.start,
          end: queryForm.end,
          company_id_list: queryForm.storeIdList,
          device_id_list: queryForm.deviceIdList,
          source: this.category || undefined, // 来源 1 纪念币， 2 大牌
        };
        // 这里调用API获取数据
        this.loadData(params);
      },
  
      loadData(params) {
        this.tableLoading = true;
        this.currentPage = 1; // 重置到第一页
        
        getRefundAnalysis(params)
          .then((res) => {
            if (res && res.code === 2000 && res.data) {
              this.order_status_analysis = res.data.order_status_analysis;
              this.refund_list = res.data.refund_list;
              this.refund_reason_analysis = res.data.refund_reason_analysis;
              this.summary = res.data.summary;
              this.unshippedCount = res.data.unshippedCount; // 更新未出货订单数量
            } else {
            }
          })
          .catch((err) => {
            Toast.fail(err.message);
            this.order_status_analysis = [];
            this.refund_list = [];
            this.refund_reason_analysis = [];
            this.summary = [];
            this.unshippedCount = 0; // 重置未出货订单数量
          })
          .finally(() => {
            this.tableLoading = false;
          });
        // 模拟加载数据
        // 实际项目中这里应该调用API
      },
      getdata(){
        var queryForm = this.getReq();
        let params = {
          start: queryForm.start,
          end: queryForm.end,
          company_id_list: queryForm.storeIdList,
          device_id_list: queryForm.deviceIdList,
          source: this.category || undefined, // 来源 1 纪念币， 2 大牌
        };
        return params;
      },
      showReasonDetail() {
        let params = this.getdata()
       this.$confirm(`确认下载数据吗？`).then(() => {
          // 下载
          getRefundAnalysisDownloadTwo(params).then((data) => {
            console.log(data,'data');
            this.download(data,params);
          })
              .catch((error) => {
                this.$message.error(error);
              });
        })
      },
  
      showStatusDetail() {
        let params = this.getdata()
       this.$confirm(`确认下载数据吗？`).then(() => {
          // 下载
          getRefundAnalysisDownload(params).then((data) => {
            console.log(data,'data');
            this.download(data,params);
          })
              .catch((error) => {
              this.$message.error(error);
              });
        })
        console.log("显示状态详情");
      },
  
      downloadTable() {
        let params = this.getdata()
       this.$confirm(`确认下载数据吗？`).then(() => {
          // 下载
          getRefundAnalysisDownloadThree(params).then((data) => {
            console.log(data,'data');
            this.download(data,params);
          })
              .catch((error) => {
              this.$message.error(error);
              });
        })
      },
      download(resp,params) {
        const fileName =params.start + "-" + params.end;
        const blob = new Blob([resp.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          const href = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = href;
          a.download = fileName;
          a.click();
          URL.revokeObjectURL(a.href);
        }
      },
      // 分页处理方法
      handleSizeChange(val) {
        this.pageSize = val;
        this.currentPage = 1; // 重置到第一页
      },
      
      handleCurrentChange(val) {
        this.currentPage = val;
      },
      
      // 处理表格排序
      handleSortChange({ column, prop, order }) {
        this.sortBy = prop;
        this.sortOrder = order;
        this.currentPage = 1; // 重置到第一页
      },
    },
    components: {
      SearchSelect,
    },
    computed: {
      storeOptions() {
        let arr = [];
        if (!Array.isArray(this.allStore)) return arr;
        this.allStore.map((val) => {
          arr.push({ label: val.name, value: val.id });
        });
        return arr;
      },
      // 排序后的数据
      sortedTableData() {
        let sortedData = [...this.refund_list];
        
        if (this.sortBy && this.sortOrder) {
          sortedData.sort((a, b) => {
            let aValue = a[this.sortBy];
            let bValue = b[this.sortBy];
            
            // 处理退款率的特殊排序（数值比较）
            if (this.sortBy === 'refund_rate') {
              aValue = parseFloat(aValue) || 0;
              bValue = parseFloat(bValue) || 0;
            } else if (typeof aValue === 'string' && typeof bValue === 'string') {
              // 字符串比较
              aValue = aValue.toLowerCase();
              bValue = bValue.toLowerCase();
            } else {
              // 数值比较
              aValue = parseFloat(aValue) || 0;
              bValue = parseFloat(bValue) || 0;
            }
            
            if (this.sortOrder === 'ascending') {
              return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
            } else {
              return aValue < bValue ? 1 : aValue > bValue ? -1 : 0;
            }
          });
        }
        
        return sortedData;
      },
      
      // 当前页数据
      currentPageData() {
        const start = (this.currentPage - 1) * this.pageSize;
        const end = start + this.pageSize;
        return this.sortedTableData.slice(start, end);
      },

      // 未出货（reason === '8'）的次数
      unshippedCount() {
        if (!Array.isArray(this.refund_reason_analysis) || this.refund_reason_analysis.length === 0) return 0;
        // refund_reason_analysis 可能包含多条，reason 可能为字符串或数字
        const match = this.refund_reason_analysis.find(item => String(item.reason) === '8');
        return match && match.count ? Number(match.count) : 0;
      },

      // 过滤出未出货状态的分析数据
      unshippedStatusList() {
        if (!Array.isArray(this.order_status_analysis) || this.order_status_analysis.length === 0) return [];
        return this.order_status_analysis.filter(s => {
          const name = this.$options.filters.outStatusFilter(s.order_out_status);
          return name !== '出货成功';
        });
      }
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .refund-analysis {
    min-height: 100vh;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    // background: linear-gradient(180deg, #101631 0%, #0b1026 100%) !important;
    padding: 20px;
    color: #ffffff;
    overflow-x: hidden;
  
    .pageTop {
      display: flex;
      margin-bottom: 10px;
      align-items: center;
  
      h1 {
        margin-right: 30px;
        font-size: 22px;
        font-weight: bold;
      }
  
      h2 {
        margin-right: 10px;
        margin-left: 10px;
        margin: 0 10px;
      }
  
      .mineSelect {
        margin: 0 10px;
      }
    }
  
    .statistics-section {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
      gap: 20px;
      margin-bottom: 30px;
      margin-top: 20px;
  
      .stat-card {
        background: rgba(255, 255, 255, 0.1);
        border-radius: 8px;
        padding: 20px;
        text-align: center;
  
        .stat-item {
          h3 {
            margin: 0 0 10px 0;
            font-size: 16px;
            color: #ffffff;
          }
  
          .stat-value {
            font-size: 32px;
            font-weight: bold;
            color: #00d4ff;
            margin-bottom: 8px;
          }
  
          .stat-desc {
            font-size: 12px;
            color: #ffcc66;
            margin-top: 5px;
          }
        }
      }
    }
  
    .refund-type-section {
      margin-bottom: 30px;
  
      h2 {
        margin-bottom: 15px;
        font-size: 18px;
        color: #ffffff;
      }
  
      .refund-type-stats {
        display: flex;
        gap: 30px;
  
        .refund-type-item {
          font-size: 16px;
          color: #ffffff;
  
          span:first-child {
            margin-right: 10px;
          }
  
          span:last-child {
            color: #00d4ff;
            font-weight: bold;
          }
        }
      }
    }
  
    .analysis-section {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 20px;
      margin-bottom: 30px;
      max-width: 100%;
      box-sizing: border-box;
  
      .analysis-card {
        background: rgba(255, 255, 255, 0.1);
        border-radius: 8px;
        padding: 20px;
  
        .card-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 25px;
          padding-bottom: 15px;
          border-bottom: 2px solid rgba(0, 212, 255, 0.3);
  
          h3 {
            margin: 0;
            font-size: 20px;
            font-weight: bold;
            color: #00d4ff;
            text-shadow: 0 0 10px rgba(0, 212, 255, 0.3);
          }
        }
  
        .reason-list,
        .status-list {
          .reason-item,
          .status-item {
            display: flex;
            align-items: center;
            gap: 15px;
            margin-bottom: 15px;
            padding: 8px 0;
            font-size: 16px;
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  
            .reason-name,
            .status-name {
              flex: 1;
              color: #ffffff;
              font-weight: 500;
              min-width: 120px;
            }
  
            .reason-count,
            .status-count {
              color: #00d4ff;
              font-weight: bold;
              font-size: 18px;
              min-width: 80px;
              text-align: center;
            }
  
            .reason-rate,
            .status-rate {
              color: #ffcc66;
              font-weight: 600;
              font-size: 16px;
              min-width: 70px;
              text-align: center;
            }
  
            .reason-desc,
            .status-desc {
              color: #ff9999;
              font-size: 14px;
              font-style: italic;
              opacity: 0.9;
              min-width: 120px;
            }
          }
  
          .reason-note,
          .status-note {
            margin-top: 20px;
            padding: 10px;
            font-size: 14px;
            color: #ffaa66;
            text-align: center;
            background: rgba(255, 170, 102, 0.1);
            border-radius: 5px;
            border-left: 4px solid #ffaa66;
          }
        }
      }
    }
  
    .pageTable {
      font-size: 16px;
      color: #ffffff;
      padding: 20px;
      border: 1px solid #5c01b8;
      border-radius: 30px;
      width: 100%;
      max-width: 100%;
      box-sizing: border-box;
      margin: 30px 0 10px 0;
      box-shadow: 0 0 10px;
      overflow-x: auto;
  
      .pageTop {
        /* 取消标题栏背景等装饰，仅保留布局 */
        background: transparent;
        border: none;
        box-shadow: none;
        backdrop-filter: none;
        margin-bottom: 20px;
      }
      
      .pagination-container {
        margin-top: 20px;
        text-align: center;
        
        .el-pagination {
          .el-pagination__total {
            color: #ffffff;
          }
          
          .el-pagination__sizes {
            .el-select {
              .el-input {
                .el-input__inner {
                  background: rgba(255, 255, 255, 0.1);
                  border: 1px solid rgba(255, 255, 255, 0.3);
                  color: #ffffff;
                }
              }
            }
          }
          
          .btn-prev,
          .btn-next {
            background: rgba(255, 255, 255, 0.1);
            border: 1px solid rgba(255, 255, 255, 0.3);
            color: #ffffff;
            
            &:hover {
              background: #5c01b8;
              border-color: #5c01b8;
            }
          }
          
          .el-pager {
            li {
              background: rgba(255, 255, 255, 0.1);
              border: 1px solid rgba(255, 255, 255, 0.3);
              color: #ffffff;
              
              &:hover {
                background: #5c01b8;
                border-color: #5c01b8;
              }
              
              &.active {
                background: #5c01b8;
                border-color: #5c01b8;
              }
            }
          }
          
          .el-pagination__jump {
            color: #ffffff;
            
            .el-input {
              .el-input__inner {
                background: rgba(255, 255, 255, 0.1);
                border: 1px solid rgba(255, 255, 255, 0.3);
                color: #ffffff;
              }
            }
          }
        }
      }
    }
  }
  
  /* ========== Visual refresh (no logic changes) ========== */
  .refund-analysis {
    /* Theme tokens */
    --ra-primary: #58d9f9;
    --ra-primary-strong: #3aa0f3;
    --ra-accent: #5c01b8;
    --ra-text: #ffffff;
    --ra-muted: rgba(255, 255, 255, 0.65);
    --ra-soft: rgba(255, 255, 255, 0.08);
    --ra-soft-2: rgba(255, 255, 255, 0.12);
    --ra-border: rgba(255, 255, 255, 0.18);
    --ra-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
  
    .pageTop {
      background: rgba(255, 255, 255, 0.18);
      border: 1px solid rgba(255, 255, 255, 0.28);
      border-radius: 14px;
      padding: 12px 14px;
      box-shadow: var(--ra-shadow);
      backdrop-filter: blur(6px);
      
      h2 {
        color: var(--ra-text);
        font-weight: 600;
      }
  
    }
  
    /* Stats cards */
    .statistics-section {
      .stat-card {
        background: var(--ra-soft);
        border: 1px solid var(--ra-border);
        border-radius: 16px;
        box-shadow: var(--ra-shadow);
        transition: transform 0.2s ease, box-shadow 0.2s ease;
      }
      .stat-card:hover {
        transform: translateY(-2px);
        box-shadow: 0 14px 32px rgba(0, 0, 0, 0.3);
      }
      .stat-item {
        h3 {
          color: var(--ra-muted);
          font-weight: 600;
          letter-spacing: 0.3px;
        }
        .stat-value {
          margin-top: 4px;
          font-size: 36px;
          background: linear-gradient(135deg, var(--ra-primary), #7cffb2);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          text-shadow: 0 0 18px rgba(88, 217, 249, 0.25);
        }
      }
    }
  
    /* Analysis cards */
    .analysis-section {
      .analysis-card {
        background: var(--ra-soft);
        border: 1px solid var(--ra-border);
        border-radius: 16px;
        box-shadow: var(--ra-shadow);
      }
      .card-header {
        border-bottom: 1px dashed rgba(255, 255, 255, 0.2);
        h3 {
          color: var(--ra-text);
          text-shadow: none;
        }
  
      }
      .reason-item, .status-item {
        border-bottom: 1px dashed rgba(255, 255, 255, 0.12);
        .reason-name, .status-name {
          color: var(--ra-text);
        }
        .reason-count, .status-count {
          color: var(--ra-primary);
          text-shadow: 0 0 12px rgba(88, 217, 249, 0.2);
        }
        .reason-rate, .status-rate {
          color: #ffd98f;
        }
      }
    }
  
    /* Table and pagination */
    .pageTable {
      border-radius: 20px;
      border: 1px solid rgba(255, 255, 255, 0.28);
      box-shadow: var(--ra-shadow);
      background: rgba(255, 255, 255, 0.16);
  
      .el-table {
        border-radius: 12px;
        overflow: hidden;
        width: 100% !important;
        margin: 0 auto;
      }
      .el-table th {
        background: rgba(0, 0, 0, 0.2) !important;
        font-weight: 600;
        letter-spacing: 0.2px;
      }
      .el-table__row:hover > td.el-table__cell {
        background-color: rgba(88, 217, 249, 0.08) !important;
        transition: background-color 0.2s ease;
      }
      .el-table td, .el-table th.is-leaf {
        border-bottom: 1px solid rgba(255, 255, 255, 0.12);
      }
  
      .pagination-container {
        .el-pagination.is-background .el-pager li:not(.disabled).active {
          background: linear-gradient(135deg, var(--ra-accent), #7a1ce0);
          border-color: transparent;
        }
        .el-pagination.is-background .el-pager li:not(.disabled):hover {
          background: rgba(92, 1, 184, 0.4);
        }
      }
    }
  
    /* Tooltip and question icon */
    ::v-deep .custom-tooltip.popper {
      background: rgba(20, 24, 42, 0.9);
      border: 1px solid rgba(255, 255, 255, 0.12);
      box-shadow: var(--ra-shadow);
      backdrop-filter: blur(6px);
    }
    .custom-question {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 22px;
      height: 22px;
      margin-left: 8px;
      border-radius: 50%;
      font-size: 14px;
      font-weight: 700;
      color: #0b1736;
      background: linear-gradient(135deg, var(--ra-primary), var(--ra-primary-strong));
      box-shadow: 0 4px 12px rgba(58, 160, 243, 0.35);
    }
  }
  
  /** {*/
  /*  scrollbar-width: thin;*/
  /*  scrollbar-color: #58d9f9 #F5F5F5;*/
  /*}*/
  /* 改变滚动条的宽度和颜色 */
  ::-webkit-scrollbar {
    background-color: transparent;
    width: 10px;
    border: 1px solid transparent;
    border-radius: 5px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #58d9f9;
    border-radius: 5px;
  }
  
  /* 改变滚动条被悬停时的颜色 */
  ::-webkit-scrollbar-thumb:hover {
    background-color: #7cffb2;
  }
  
  /* 改变滚动条的轨道宽度和颜色 */
  ::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 5px;
  }
  
  @media (max-width: 1200px) {
    .refund-analysis {
      .analysis-section {
        grid-template-columns: 1fr;
      }
    }
  }
  </style>
  
  <style>
  .refund-analysis .el-button--primary {
    background: #5c01b8;
    border-color: #5c01b8;
  }
  
  .refund-analysis .el-button--primary:hover {
    background: #7014d1;
    border-color: #7014d1;
  }
  
  .refund-analysis .el-table {
    background: transparent;
  }
  
  .refund-analysis .el-table th,
  .refund-analysis .el-table td {
    background: transparent;
    border-color: rgba(255, 255, 255, 0.1);
    color: #ffffff;
  }
  
  .refund-analysis
    .el-table--striped
    .el-table__body
    tr.el-table__row--striped
    td {
    background: rgba(255, 255, 255, 0.05);
  }
  
  .refund-analysis .el-table th {
    background: rgba(255, 255, 255, 0.1) !important;
    color: #ffffff !important;
  }
  
  .refund-analysis .pageTable .el-table {
    background: transparent !important;
    color: #fff;
    font-size: 16px;
  }
  
  .refund-analysis .pageTable .el-table tr {
    background: transparent;
  }
  
  .refund-analysis .pageTable .el-table th.el-table__cell {
    background: transparent !important;
    color: #fff;
  }
  
  .refund-analysis
    .pageTable
    .el-table--enable-row-hover
    .el-table__body
    tr:hover
    > td.el-table__cell {
    color: #58d9f9;
    font-weight: bold;
    background: transparent !important;
  }
  
  .refund-analysis .pageTable .el-table th.el-table__cell.is-leaf {
    border-bottom: 1px solid #5c01b8;
  }
  
  /* 排序图标样式 */
  .refund-analysis .pageTable .el-table .sort-caret {
    border-width: 5px;
  }
  
  .refund-analysis .pageTable .el-table .sort-caret.ascending {
    border-bottom-color: #58d9f9;
  }
  
  .refund-analysis .pageTable .el-table .sort-caret.descending {
    border-top-color: #58d9f9;
  }
  
  .refund-analysis .pageTable .el-table th.is-sortable {
    background: rgba(88, 217, 249, 0.1) !important;
  }
  
  .refund-analysis .pageTable .el-table th.is-sortable:hover {
    background: rgba(88, 217, 249, 0.2) !important;
  }
  
  .refund-analysis .pageTable .el-table th.is-sortable .cell {
    color: #58d9f9 !important;
    font-weight: bold;
  }
  
  .refund-analysis .el-button {
    margin-left: 10px;
    border-radius: 20px;
    background: transparent;
    color: #ffffff;
    height: 40px;
  }
  
  .refund-analysis .el-button:hover {
    color: #ffffff;
    background-color: #5c01b8;
    border-color: #5c01b8;
  }
  
  /** {*/
  /*  scrollbar-width: thin;*/
  /*  scrollbar-color: #58d9f9 #F5F5F5;*/
  /*}*/
  /* 改变滚动条的宽度和颜色 */
  .refund-analysis .pageTable ::-webkit-scrollbar {
    background-color: transparent;
    width: 10px;
    border: 1px solid transparent;
    border-radius: 5px;
  }
  .refund-analysis .pageTable ::-webkit-scrollbar-thumb {
    background-color: #58d9f9;
    border-radius: 5px;
  }
  
  /* 改变滚动条被悬停时的颜色 */
  .refund-analysis .pageTable ::-webkit-scrollbar-thumb:hover {
    background-color: #7cffb2;
  }
  
  /* 改变滚动条的轨道宽度和颜色 */
  .refund-analysis .pageTable ::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 5px;
  }
  ::v-deep .custom-tooltip {
    background-color: rgba(0, 0, 0, 0.7);
    color: #fff;
    border: none;
    border-radius: 4px;
    padding: 10px;
    font-size: 14px;
    line-height: 1.4;
    max-width: 300px;
    word-break: break-word;
    text-align: center;
  }
  
  ::v-deep .custom-tooltip .popper__arrow {
    border-top-color: rgba(0, 0, 0, 0.7);
  }
  .custom-question {
    display: inline-block;
    text-align: center;
    line-height: 24px;
    width: 24px;
    height: 24px;
    font-size: 16px;
    font-weight: 700;
    margin-left: 10px;
    color: #fff;
    border-radius: 50%;
    background: linear-gradient(to right, #58d9f9, #3aa0f3);
  }

  /* 响应式设计 */
  @media (max-width: 1200px) {
    .analysis-section {
      grid-template-columns: 1fr;
      gap: 20px;
    }
  }

  @media (max-width: 768px) {
    padding: 10px;
    
    .pageTop {
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
      
      h1, h2 {
        margin: 5px 0;
      }
    }
    
    .statistics-section {
      grid-template-columns: 1fr;
      gap: 15px;
    }
    
    .analysis-section {
      grid-template-columns: 1fr;
      gap: 15px;
    }
    
    .pageTable {
      padding: 15px;
      margin: 20px 0 10px 0;
    }
  }
  </style>